import {Body} from 'shells/typography/body';

import styles from './research-fields.module.css';

type Field = {
    key: string;
    label: string;
    value: string;
};

type Props = {
    fields: Field[];
};

export function ResearchFields({fields}: Props) {
    if (fields.length === 0) {
        return null;
    }

    return (
        <div className={styles.container}>
            {fields.map((field) => (
                <div key={field.key} className={styles.field}>
                    <Body size='small' color='dark' isBold={true}>
                        {field.label}
                    </Body>
                    <Body size='small'>{field.value}</Body>
                </div>
            ))}
        </div>
    );
}
